import { useEffect } from "react";
import { reportSharedVolumeFailure } from "@/lib/shared-volume-failure";
import {
	selectEffectiveEnvironmentId,
	selectEffectiveEnvironmentRunnerName,
	useChatStore,
} from "@/stores/useChatStore";
import { useCloudSharedVolumeStore } from "@/stores/useCloudSharedVolumeStore";

/**
 * 開いているチャット (下書きなら送信先) の環境を追い、クラウドの環境なら付いている共有ボリュームを取る。出すたび
 * (起動してツリーが出たときを含む) に取り直す。ファイルのツリーに出すか (付いているボリュームがあるか) を返す。
 */
export function useCloudSharedVolumes(): boolean {
	const environmentId = useChatStore(selectEffectiveEnvironmentId);
	const onCloud = useChatStore((s) => selectEffectiveEnvironmentRunnerName(s) === null);
	const visible = useCloudSharedVolumeStore(
		(s) =>
			onCloud &&
			environmentId !== null &&
			s.environmentId === environmentId &&
			(s.volumes?.length ?? 0) > 0,
	);

	useEffect(() => {
		useCloudSharedVolumeStore.getState().track(environmentId);
	}, [environmentId]);

	useEffect(() => {
		if (environmentId === null || !onCloud) return;
		reportSharedVolumeFailure(
			useCloudSharedVolumeStore.getState().refresh(),
			"共有ボリュームの一覧を取得できませんでした。",
		);
	}, [environmentId, onCloud]);

	return visible;
}
